var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./StudentsTable.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-318d2bc2!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./StudentsTable.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/onlineRoundtables/components/summaryComponents/StudentsTable.vue
// module id = 366
// module chunks = 61